import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormTableComponent } from './dynamic-form-table.component';
import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { DynamicFormCellModule } from '../dynamic-form-cell/dynamic-form-cell.module';
import { DynamicFormCardModule } from '../dynamic-form-card/dynamic-form-card.module';
import { LetDirective } from '@ngrx/component';

@NgModule({
  declarations: [DynamicFormTableComponent],
  imports: [
    CommonModule,
    MaterialModule,
    UiModule,
    DynamicFormCellModule,
    DynamicFormCardModule,
    LetDirective,
  ],
  exports: [DynamicFormTableComponent],
})
export class DynamicFormTableModule {}
